import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { PushSubscribersState, PushSubscribersFilter } from './types';

export const actions: ActionTree<PushSubscribersState, RootState> = {
    async getPushSubscribers({ commit }, params: PushSubscribersFilter) {
        commit('setLoading', true);
        try {
            const response = await axios.get('/acapi/push/subscribers/list', { params });
            if (params?.page_number > 1) {
                commit("pushSubscribers", response.data?.subscribers);
            } else {
                commit('setSubscribers', response.data?.subscribers);
            }
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async getPushSubscribersItem({ commit }, id: number) {
        commit('setLoading', true);
        try {
            const { data } = await axios.get(`/acapi/push/subscribers/list/${id}`);
            commit('setSubscriberItem', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async deletePushSubscriber({ commit, dispatch }, id: number) {
        commit('setLoading', true);
        try {
            const response = await axios.delete(`/acapi/push/subscribers/list/${id}`);
            const filter = JSON.parse(sessionStorage.getItem('PushSubscriberFilter') || '');
            await dispatch('getPushSubscribers', filter);
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async deletePushSubscribers({ commit, dispatch }, data: { ids: number[], filter: PushSubscribersFilter }) {
        commit('setLoading', true);
        try {
            const response = await axios.delete('/acapi/push/subscribers/list', { data: { ids: data.ids } });
            await dispatch('getPushSubscribers', data.filter);
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    }
};
